module.exports = __webpack_public_path__ + "static/img/14000755.56f56d62.png";